import React from 'react';

import styled from 'styled-components';
import {Contents, DropdownMenu} from 'view/components';
import {useRecoilState, useSetRecoilState} from "recoil";
import {Alert} from "../../../../state";
import CloseBtn from "../../../components/common/CloseBtn";

interface PopupProps {
    onChange?: any;
    value?: string;
    headerText?: any;
    onChangeSubItem?: any;
    subItemValue?: any;
    onClick: any;
    title?:any;
    desc?:any
    width?:any;
    buttonText?:any
    placeholder?:any
    subPlaceholder?:any
    filter?:any
    onClose?:any
}

const Popup: React.FC<PopupProps> = ({
    onChange = () => {},
    onChangeSubItem = () => {},
    subItemValue = "",
    width = 600,
    value = "",
    onClick,
    headerText = "Class Title",
    title = "How about a working title?",
    desc = "It’s ok if you can’t think of a good title now. You can change it later.",
    buttonText = "Continue",
    placeholder = "Enter a title",
    subPlaceholder = "Chapter title",
    filter = false,
    onClose= () => {}
}) => {
    const setAlert = useSetRecoilState(Alert)
    return (
        <Container
            onClick={(e) => {e.stopPropagation()}}
        >
            <Contents title={headerText}>
                <CloseBtn style={{ position:"absolute", right:0, top:0}}
                          onClick={()=>{
                              // if(!isAdminState){
                              //     setSelected("Classes");
                              //     navigate("/main/classes")
                              // }else{
                              //     setSelected("Classes");
                              //     navigate("/main/classes")
                              //     setSelectedSubMenu("In Progress")
                              // }
                              onClose()
                          }}
                />
                <Inner style={{width:width, paddingTop:title === "" ? 0 : 30}} >
                    {
                    <h1>{title}</h1> && 
                    title !== "" 
                    }
                    <p>{desc}</p>
                    <FormBoxItemWrap>
                        {
                            subPlaceholder &&
                            <li style={{marginTop:0}}>
                                <FormItem>
                                    {/*<input*/}
                                    {/*    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {*/}
                                    {/*        onChangeSubItem(e.target.value);*/}
                                    {/*    }}*/}
                                    {/*    type="text"*/}
                                    {/*    value={subItemValue}*/}
                                    {/*    placeholder={subPlaceholder}*/}
                                    {/*    maxLength={70}*/}
                                    {/*/>*/}
                                    <DropdownMenu
                                        selected={
                                            subItemValue || ""
                                        }
                                        altText="Select Category"
                                        items={["INTRODUCTION", "CHAPTER", "CONCLUSION"]}
                                        state={"chapterType"}
                                        // // index={index}
                                        onClick={onChangeSubItem}
                                    />

                                </FormItem>
                            </li>
                        }
                        <li
                            style={{marginTop:20}}
                        >
                            <FormItem>
                                <input
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                        onChange(e.target.value);
                                    }}
                                    type="text"
                                    value={value}
                                    placeholder={"Enter a title"}
                                    maxLength={70}
                                />
                                <TextLength>{70 - value.length}</TextLength>
                           
                            </FormItem>
                        </li>

                      
                    </FormBoxItemWrap>
                    <Continue
                        onClick={() => {
                            if(subItemValue.length == 0) {
                                setAlert({
                                    isActive:true,
                                    text:"Select Category",
                                    desc:"",
                                    type:"warn",
                                    color:"blue",
                                    time: 1300
                                })
                                return;
                            }

                            if (value.length === 0) {
                                // alert("Please enter title");
                                setAlert({
                                    isActive:true,
                                    text:"Enter a title",
                                    desc:"",
                                    type:"warn",
                                    color:"blue",
                                    time: 1300
                                })
                                return;
                            }

                            if(subItemValue.length !== 0 && value.length !== 0){
                                onClick();
                            }
                        }}
                    >
                        <span>{buttonText}</span>
                    </Continue>
                </Inner>
            </Contents>
        </Container>
    );
};
export default Popup;

const Container = styled.div`
    
    h1 {
        font-size: 28px;
        font-weight: 700;
        color: #333;
        margin-bottom: 30px;
    }
    @media screen and (max-width: 768px) {
        margin: 0 auto;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 90%!important;
    }
`;
const Inner = styled.div`
    @media screen and (max-width: 768px) {
        margin: 0 auto;
        width: 100%!important;
    }
    padding: 30px 40px 40px 40px;
    width: 700px;
    display: flex;
    flex-direction: column;
    align-items: center;
    p {
        font-size: 18px;
        font-weight: 400;
        margin-bottom: 40px;
    }
`;
const FormBoxItemWrap = styled.ul`
    width: 100%;
    margin-bottom: 40px;
    > li {
        font-size: 16px;
        margin: 8px 0 0 0;
    }
`;

const FormItem = styled.div`
    position: relative;
    > input[type="text"],
    select,
    textarea {
        width: 100%;
        font-family: Europa-Regular;
        font-size: 16px;
        outline: none;
        border-radius: 8px;
        border: solid 1px rgba(51, 51, 51, 0.3);
        padding: 12px 16px;
        &::placeholder {
            color: #ddd;
        }
    }
    > input[type="text"] {
        height: 48px;
    }
    > select {
        height: 48px;
        -webkit-appearance: none;
        appearance: none;
    }
`;

const TextLength = styled.span`
    color: rgba(51, 51, 51, 0.6);
    font-weight: 700;
    position: absolute;
    right: 16px;
    top: 17px;
`;

const Continue = styled.div`
    padding: 11px 30.5px;
    border-radius: 6px;
    border: solid 1px #333;
    cursor: pointer;
    span {
        font-size: 18px;
        font-weight: 400;
        color: #333;
    }
`;
